var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.background_check_documents.length
      ? _c("div", { staticClass: "unset_background_check_documents" }, [
          _c("p", [
            _vm._v(
              "\n      Profissional ainda nao chegou na etapa de verificacao dos antecedentes\n      :(\n    "
            )
          ])
        ])
      : _c(
          "div",
          [
            _c(
              "v-btn",
              {
                staticClass: "ma-2",
                attrs: {
                  href: _vm.buildCombateAFraudeLink(
                    _vm.background_check_documents[0].external_id
                  ),
                  color: "secondary",
                  target: "_blank"
                }
              },
              [_vm._v("\n      Consultar execução\n    ")]
            ),
            _vm._v(" "),
            _c("v-data-table", {
              attrs: {
                headers: _vm.headers,
                items: _vm.background_check_documents,
                loading: _vm.loader,
                "show-expand": ""
              },
              scopedSlots: _vm._u([
                {
                  key: "item.document_type",
                  fn: function(ref) {
                    var headers = ref.headers
                    var item = ref.item
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("getBackgroundDocumentTypeStatuses")(
                              item.document_type
                            )
                          ) +
                          "\n      "
                      )
                    ]
                  }
                },
                {
                  key: "item.status",
                  fn: function(ref) {
                    var headers = ref.headers
                    var item = ref.item
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm._f("getStatuses")(item.status, "name")) +
                          "\n      "
                      )
                    ]
                  }
                },
                {
                  key: "item.approved",
                  fn: function(ref) {
                    var headers = ref.headers
                    var item = ref.item
                    return [
                      item.status === "reproved" || item.status === "approved"
                        ? _c("p", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm._f("isApproved")(item.approved).name
                                ) +
                                "\n        "
                            )
                          ])
                        : _c("p", [
                            _vm._v("\n          Em andamento\n        ")
                          ])
                    ]
                  }
                },
                {
                  key: "item.created_at",
                  fn: function(ref) {
                    var headers = ref.headers
                    var item = ref.item
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("formatDate")(item.created_at, "DD/MM/Y")
                          ) +
                          "\n      "
                      )
                    ]
                  }
                },
                {
                  key: "item.updated_at",
                  fn: function(ref) {
                    var headers = ref.headers
                    var item = ref.item
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("formatDate")(item.updated_at, "DD/MM/Y")
                          ) +
                          "\n      "
                      )
                    ]
                  }
                },
                {
                  key: "expanded-item",
                  fn: function(ref) {
                    var headers = ref.headers
                    var item = ref.item
                    return [
                      _c(
                        "td",
                        { attrs: { colspan: headers.length } },
                        [
                          _c("p", { staticClass: "mt-5" }, [
                            _c("b", [_vm._v("Combate a fraude ID:")]),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formatExternalId(item.external_id)) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _vm.isDocumentHandled(item.status)
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "yellow",
                                    loading: item.documentApprovingLoader,
                                    small: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.approveDocument(item)
                                    }
                                  }
                                },
                                [_c("span", [_vm._v("Aprovar Documento")])]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-303540d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-303540d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Professionals/Edit/Tabs/Documents/BackgroundCheck.vue
// module id = null
// module chunks = 